$bog_blitz_lobby_game_leaderboard $mol_view
	players_dict null
	my_lord_str \
	is_host false
	sub <= board_content /
	My_row $mol_view
		sub <= my_row_content /
	Top $mol_view
		sub /
			<= Top_title $mol_paragraph
				title @ \Top 10
			<= Top_list $mol_list
				rows <= top_rows /
	Bottom $mol_view
		sub /
			<= Bottom_title $mol_paragraph
				title @ \Bottom 10
			<= Bottom_list $mol_list
				rows <= bottom_rows /
	Row*0 $bog_blitz_lobby_game_leaderboard_row
		rank <= row_rank* 0
		name <= row_name* \
		score <= row_score* 0
		mine <= row_mine* false
